module.exports = __webpack_public_path__ + "static/media/planinternational.19244ffd.png";